import React from 'react';
import './Skills.css';

const Skills: React.FC = () => {
  const skills = [
    { name: 'JavaScript', level: 'Advanced' },
    { name: 'TypeScript', level: 'Advanced' },
    { name: 'React', level: 'Advanced' },
    { name: 'Node.js', level: 'Intermediate' },
    { name: 'HTML/CSS', level: 'Advanced' },
    { name: 'Python', level: 'Intermediate' },
    { name: 'Git', level: 'Advanced' },
    { name: 'SQL', level: 'Intermediate' },
  ];

  return (
    <section className="skills">
      <div className="skills-container">
        <h1 className="section-title">Skills</h1>
        <div className="skills-content">
          <div className="skills-grid">
            {skills.map((skill, index) => (
              <div key={index} className="skill-item">
                <h3 className="skill-name">{skill.name}</h3>
                <span className="skill-level">{skill.level}</span>
              </div>
            ))}
          </div>
          <div className="skills-description">
            <p>
              I have experience with a wide range of technologies and frameworks.
              I'm always eager to learn new tools and techniques to stay current
              in the ever-evolving world of software development.
            </p>
            <p>
              My focus is on creating robust, scalable applications with clean
              code and best practices. I enjoy working with both frontend and
              backend technologies.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;